import {atom} from 'jotai'


export const selectedTagsAtom = atom([])

export const allTagsAtom =atom([])